<template>
  <div id="app">
    <div class="login-container">
      <!-- 头部区域 -->
      <div class="login-header">
        <img :src="logo" alt="Logo" class="login-logo">
        <h1 class="login-title">欢迎登录{{title}}服务平台</h1>
        
      </div>
      
      <!-- 登录方式选项卡 -->
      <div class="login-tabs">
        <van-tabs v-model="activeTab" animated swipeable >
          <van-tab name="1" title="账号密码">
            <div class="login-form">
              <van-form @submit="loginAndBind">
                <van-field
                  v-model="passwordForm.username"
                  name="username"
                  label="用户名"
                  placeholder="请输入证件号/手机号"
                  :rules="[{ required: true, message: '' }]"
                  left-icon="user-o"
                />
                <van-field
                  v-model="passwordForm.password"
                  type="password"
                  name="password"
                  label="密码"
                  placeholder="请输入密码"
                  :rules="[{ required: true, message: '' }]"
                  left-icon="lock"
                />
                <div style="margin: 16px;">
                  <van-button round block type="primary" native-type="submit" class="custom-button">
                    登录
                  </van-button>
                </div>
              </van-form>
            </div>
          </van-tab>
          
          <van-tab title="短信验证码" name="2">
            <div class="login-form">
              <van-form @submit="loginAndBind">
                <van-field
                  v-model="smsForm.phone"
                  name="phone"
                  label="手机号"
                  placeholder="请输入手机号"
                  :rules="[
                    { required: true, message: '' },
                    { pattern: /^1[0-9]\d{9}$/, message: '手机号格式不正确' }
                  ]"
                  left-icon="phone-o"
                />
                <van-field
                  v-model="smsForm.code"
                  center
                  clearable
                  name="code"
                  label="验证码"
                  placeholder="请输入验证码"
                  :rules="[{ required: true, message: '' }]"
                  left-icon="comment-o"
                >
                  <template #button>
                    <van-button
                      size="small"
                      :type="countdown > 0 ? 'default' : 'primary'"
                      :disabled="countdown > 0 || !isPhoneValid"
                      @click="onSendSms"
                    >
                      {{ countdown > 0 ? `${countdown}s后重新获取` : '获取验证码' }}
                    </van-button>
                  </template>
                </van-field>
                <div style="margin: 16px;">
                  <van-button round block type="primary" native-type="submit" class="custom-button">
                    登录
                  </van-button>
                </div>
              </van-form>
            </div>
          </van-tab>
        </van-tabs>
      </div>
      
      <!-- 其他操作 
      <div class="login-actions">
        <van-row>
          <van-col span="12">
            <van-checkbox v-model="remember" icon-size="16px">记住我</van-checkbox>
          </van-col>
          <van-col span="12" style="text-align: right;">
            <van-button type="default" size="small" @click="onForgetPassword">忘记密码?</van-button>
          </van-col>
        </van-row>
      </div>
      
       第三方登录 
      <div class="third-party-login">
        <div class="third-party-icon">
          <van-icon name="wechat" size="20px" color="#07C160" />
        </div>
        <div class="third-party-icon">
          <van-icon name="alipay" size="20px" color="#1677FF" />
        </div>
        <div class="third-party-icon">
          <van-icon name="weibo" size="20px" color="#FF8200" />
        </div>
      </div>-->
      
      <!-- 页脚 -->
      <div class="login-footer">
        <p style="margin-top: 10px;">©2025 {{title}} 版权所有</p>
      </div>
    </div>
  </div>

</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import { Tab, Tabs } from 'vant';
export default {
    // import引入的组件需要注入到对象中才能使用
    components: {
    'van-tabs': Tabs,
    'van-tab': Tab      
    },
    data() {
      return {
        
        	title: process.env.VUE_APP_SYSTEM_NMAE,
			    logo:require('@/'+process.env.VUE_APP_LOGO_URL),//'https://jkx.ebao51.cn/yh_bcbaseweb/admin/qiyeweixin/case/img/lys.png'

          activeTab: 1,
          
          thirdCode:'',
          thirdType:'',
          channelCode:'',

          disabledCode: false,

          countdown: 0,
          passwordForm: {
            username: '',
            password: ''
          },
          smsForm: {
            phone: '',
            code: ''
          },

      };
    },
    computed: {
        isPhoneValid() {
          return /^1[0-9]\d{9}$/.test(this.smsForm.phone);
        }
    },   
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        //alert(process.env.VUE_APP_WX_APP_ID);
        
        this.init();
    },     
    methods: {

        init(){
            let {thirdType,thirdCode,channelCode} = this.$route.query; //获取query
            
            debugger;

            console.log("thirdType:"+thirdType);
            console.log("thirdCode:"+thirdCode);
            console.log("channelCode:"+channelCode);

            if(thirdCode && thirdType){
                this.channelCode =channelCode;
                this.thirdType = thirdType;
                this.thirdCode = thirdCode;

                this.loginByThird();
            }
        },
        //第三方登录
        loginByThird(){
            let data= {
                thirdCode:this.thirdCode,
                thirdType:this.thirdType,
                ccode:this.channelCode,
            };
            this.$getRequestData20('loginByThird', data)
            .then(result =>{
              if(result.resultCode!='0000'){
                console.log(result);
              }else{
                let {authFlag,fullName, lysCstUserId} = result.bizData;

                if(result.bizData.result=='y'){
                    this.onLoginSucced(authFlag,fullName,lysCstUserId);
                }
              }
            })
            .catch(err => {
              console.log(err);
            })
        },
        //查询客户信息
        loginAndBind(){
            let data= {
                
                thirdCode:this.thirdCode,//
                thirdType:this.thirdType,
                ccode:this.channelCode,

                loginType: this.activeTab==2?'sms':'id',//   sms：短信验证码/id：证件号+密码

                userName:"",//    手机号码/证件号
                passWord:"",//    密码或验证码
            };

            console.log(this.activeTab);

            if(this.activeTab==1){
               data.loginType ="id"; 
               data.userName = this.passwordForm.username;
               data.passWord = this.passwordForm.password;
            }else{
               data.loginType ="sms"; 
               data.userName = this.smsForm.phone;
               data.passWord = this.smsForm.code;
            }

            console.log(data);

          this.$getRequestData20('loginAndBind', data)
          .then(result =>{
            if(result.resultCode != '0000'){
               
               this.$toast.fail(result.msg);

              console.log(result);
            }else{
              let {authFlag,fullName, lysCstUserId} = result.bizData;

                  if(result.bizData.result=='y'){
                      this.onLoginSucced(authFlag,fullName,lysCstUserId);
                  }else{


                      this.$toast.fail("登录失败");
                  }
            }
          })
          .catch(err => {
            this.$toast.fail(err);
            console.log(err);
          })
        },
        
        //发送短信验证码
        onSendSms(){
            this.$getRequestData20('sendLoginAuthcode', {mobilePhone:this.smsForm.phone})
                  .then(result => {
                      if(result.resultCode === '0000'){
                          this.disabledCode = true;
                          this.smsCodeCount();
                          console.log(result)	
                      }else{
                        this.$toast.fail(result.msg);
                        this.disabledCode = false;
                    }
            }) 
            .catch(err => {
              this.$toast.fail(err);
              console.log(err);
          })

        },

        //登录成功
        onLoginSucced(authFlag,fullName,lysCstUserId){

          //this.$toast.success('登录成功');
          
          sessionStorage.setItem('cstFullName', fullName);
          
          sessionStorage.setItem('lysCstUserId', lysCstUserId);
          
          sessionStorage.setItem('thirdCode', this.thirdCode);
          sessionStorage.setItem('thirdType', this.thirdType);

          if(authFlag && authFlag=='y'){
              this.$router.push({ path: '/index/homePage' });
          }else{
            //签名页面
             this.$router.push({ path: '/agreement/agreementPage' });
          }
        },

        //公共函数
        smsCodeCount(){        
            // 开始倒计时
            this.countdown = 60;
            const timer = setInterval(() => {
              this.countdown -= 1;
              if (this.countdown <= 0) {

                this.disabledCode = false;

                clearInterval(timer);
              }
            }, 1000);
        
        }

    },

    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {},
    // 生命周期 - 创建之前
    beforeCreate() {},
    // 生命周期 - 挂载之前
    beforeMount() {},
    // 生命周期 - 更新之前
    beforeUpdate() {},
    // 生命周期 - 更新之后
    updated() {},
    // 生命周期 - 销毁之前
    beforeDestroy() {},
    // 生命周期 - 销毁完成
    destroyed() {},
    // 如果页面有keep-alive缓存功能，这个函数会触发
    activated() {},
};
</script>

<style lang="less" scoped>
//@import url(); 引入公共css类
    body {
      background-color: #f7f8fa;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    }
    .login-container {
      max-width: 420px;
      margin: 0 auto;
      padding: 20px;
    }
    .login-header {
      text-align: center;
      margin: 40px 0;
    }
    .login-logo {
      width: 150px;
      height: 150px;
      margin-bottom: 15px;
    }
    .login-title {
      font-size: 24px;
      color: #323233;
      font-weight: 500;
      margin-bottom: 10px;
    }
    .login-subtitle {
      font-size: 14px;
      color: #969799;
    }
    .login-tabs {
      margin-top: 20px;
    }
    .login-form {
      margin-top: 20px;
    }
    .login-actions {
      margin-top: 30px;
    }
    .login-footer {
      margin-top: 50px;
      text-align: center;
      color: #969799;
      font-size: 18px;
    }
    .van-field__left-icon {
      color: #1989fa;
    }
    .custom-button {
      border-radius: 5px;
      background-color: #2176ff;
    }
    .third-party-login {
      margin-top: 30px;
      text-align: center;
    }
    .third-party-title {
      position: relative;
      color: #969799;
      font-size: 14px;
      margin: 20px 0;
    }
    .third-party-title::before,
    .third-party-title::after {
      content: "";
      position: absolute;
      top: 50%;
      width: 30%;
      height: 1px;
      background-color: #ebedf0;
    }
    .third-party-title::before {
      left: 0;
    }
    .third-party-title::after {
      right: 0;
    }
    .third-party-icons {
      display: flex;
      justify-content: center;
      margin-top: 15px;
    }
    .third-party-icon {
      width: 44px;
      height: 44px;
      margin: 0 10px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #f1f1f1;
      color: #333;
    }
    .quick-actions {
      display: flex;
      justify-content: space-between;
      margin-top: 15px;
    }
    .count-down-btn {
      color: #1989fa;
    }

    ::v-deep .van-tab__text,::v-deep .van-cell__title,::v-deep .van-field__body, ::v-deep .van-button__content{
      font-size: 16px!important;
    }

    ::v-deep .van-field__label{
      width: 5.5em;  
    }

</style>
